<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="ded"><span class="big2">For Rita</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795317392_epub_ded_r1.vue?186fa722